// Static site content for Dirty Wrenches Automotive
import { SiBmw, SiAudi, SiVolkswagen, SiSubaru, SiPorsche } from "react-icons/si";
import { MercedesLogo } from "../components/MercedesLogo";

export const SITE = {
  name: "Dirty Wrenches",
  fullName: "Dirty Wrenches Automotive",
  tagline: "Three Mechanics. One Obsession. European & Subaru Imports.",
  est: "EST. 2022",
  contact: {
    phone: "(541) 303-3495",
    email: "dirtywrenches007@gmail.com",
    address: "1055 N 1st Pl, Suite 3A, Hermiston, OR 97838",
    hours: [
      { d: "Mon — Fri", h: "9:00 AM – 5:00 PM" },
      { d: "Saturday", h: "Closed" },
      { d: "Sunday", h: "Closed" },
    ],
  },
  warranty: {
    months: 12,
    miles: 12000,
    headline: "12-month / 12,000-mile warranty on every job",
    short: "12 mo / 12k mi warranty",
  },
};

export const BRANDS = [
  { key: "bmw", name: "BMW", icon: SiBmw, blurb: "M-series, N54/N55 builds, coding & DME tuning, full chassis service." },
  { key: "audi", name: "Audi", icon: SiAudi, blurb: "B-series, S/RS lineup, quattro driveline, DSG / S-tronic specialists." },
  { key: "vw", name: "Volkswagen", icon: SiVolkswagen, blurb: "MK6/7/8, GTI & Golf R, APR / Unitronic flashes, timing & carbon clean." },
  { key: "mb", name: "Mercedes-Benz", icon: MercedesLogo, blurb: "C, E, AMG, M278/M276 service, air suspension, SCN coding." },
  { key: "subaru", name: "Subaru", icon: SiSubaru, blurb: "WRX/STI, FA20/EJ257 builds, AWD diagnostics, Cobb tuning." },
  { key: "porsche", name: "Porsche", icon: SiPorsche, blurb: "911, Cayman, Macan & Cayenne — PDK service, IMS solutions, PIWIS diagnostics." },
];

export const SERVICES = [
  {
    code: "01",
    title: "Diagnostics",
    desc: "Manufacturer-grade scan tools across all six marques. We find the fault — not just the code.",
    bullets: ["ISTA / ODIS / Star / SSM4 / PIWIS", "Live data & module coding", "Pre-purchase inspection"],
  },
  {
    code: "02",
    title: "Performance Tuning",
    desc: "Flash tunes, stage builds and dyno-validated calibrations for street and track.",
    bullets: ["Cobb / APR / Unitronic", "MHD & bootmod3 for BMW", "Dyno tuning available"],
  },
  {
    code: "03",
    title: "Engine & Transmission",
    desc: "Top-end rebuilds, timing services, DSG / ZF / DCT clutch packs and full driveline work.",
    bullets: ["Timing chain & belt", "DSG mechatronic service", "Forged builds"],
  },
  {
    code: "04",
    title: "Brakes & Suspension",
    desc: "Big brake kits, coilovers, alignments and bushing refresh. Track-day prep welcome.",
    bullets: ["Brembo / StopTech / AP", "KW / Bilstein / Öhlins", "Corner-balance & alignment"],
  },
  {
    code: "05",
    title: "Maintenance",
    desc: "The dull stuff done properly — oil, fluids, filters, inspections, on time, every time.",
    bullets: ["Factory-spec fluids", "Carbon cleaning (walnut blast)", "Pre-track inspection"],
  },
];

export const GALLERY = [
  {
    url: "https://images.unsplash.com/photo-1712194289451-4044105509f0?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    alt: "BMW M4 front quarter",
    tag: "BMW M4",
    size: "lg",
  },
  {
    url: "https://images.unsplash.com/photo-1611821064430-0d40291d0f0b?w=1400&q=85",
    alt: "Porsche 911 GT3 in the city",
    tag: "Porsche 911 GT3",
    size: "md",
  },
  {
    url: "https://images.unsplash.com/photo-1617814076367-b759c7d7e738?w=1400&q=85",
    alt: "Mercedes-AMG GT R black",
    tag: "AMG GT R",
    size: "md",
  },
  {
    url: "https://images.unsplash.com/photo-1620899011820-e22f724e8084?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    alt: "Subaru BRZ modified",
    tag: "Subaru BRZ",
    size: "md",
  },
  {
    url: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=1400&q=85",
    alt: "Audi RS6 Avant black",
    tag: "Audi RS6",
    size: "md",
  },
  {
    url: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1400&q=85",
    alt: "Porsche Panamera Turbo at dusk",
    tag: "Porsche Panamera",
    size: "md",
  },
  {
    url: "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    alt: "Mechanic working on an import engine bay",
    tag: "Behind the bay",
    size: "lg",
  },
  {
    url: "https://images.unsplash.com/photo-1555215695-3004980ad54e?w=1400&q=85",
    alt: "BMW M5 in motion",
    tag: "BMW M5",
    size: "md",
  },
  {
    url: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?w=1400&q=85",
    alt: "Mercedes-AMG GT S yellow",
    tag: "AMG GT S",
    size: "md",
  },
  {
    url: "https://images.unsplash.com/photo-1568844293986-8d0400bd4745?w=1400&q=85",
    alt: "BMW M4 Coupé in yellow",
    tag: "BMW M4",
    size: "md",
  },
  {
    url: "https://images.unsplash.com/photo-1493238792000-8113da705763?w=1400&q=85",
    alt: "Audi R8 rear taillights",
    tag: "Audi R8",
    size: "md",
  },
  {
    url: "https://images.unsplash.com/photo-1570129476815-ba368ac77013?crop=entropy&cs=srgb&fm=jpg&w=1100&q=85",
    alt: "Workshop tools",
    tag: "Tools of the trade",
    size: "sm",
  },
];

export const STATS = [
  { n: "3", label: "Mechanics on the floor" },
  { n: "6", label: "Import marques specialised" },
  { n: "10+", label: "Years on these cars" },
  { n: "1", label: "Bay you actually trust" },
];

export const CREW = [
  {
    role: "Owner",
    name: "Travis M.",
    spec: "Operations · Imports · 20+ yrs",
    bio: "Runs the shop and day-to-day operations. Two decades as a lead mechanic across corporate dealerships and private shops, with deep import experience — he's the one who's seen how it's done right and wrong, and built Dirty Wrenches around the right way.",
    tenure: "Owner",
  },
  {
    role: "Drivetrain Specialist",
    name: "Devon K.",
    spec: "VW / MB · DSG / 7G-Tronic · 9 yrs",
    bio: "Mechatronic surgery, clutch packs and the dark art of making German gearboxes behave.",
    tenure: "Recently joined",
  },
  {
    role: "Performance & Subaru",
    name: "Jess T.",
    spec: "Subaru / Tuning · 8 yrs",
    bio: "WRX/STI builds, dyno calibrations and the only person here who can spell ‘rotational mass.’",
    tenure: "Recently joined",
  },
];
